<a *ngIf="!editIcon && (!commitment || !commitment.commitmentID)" (click)="openAddOrEditCommitment()"
    style="min-width: 10px  !IMPORTANT; min-height: 10px  !IMPORTANT;  line-height: 10px; padding:4px"
    matTooltip="הוסף התחייבות" mat-stroked-button>
    <mat-icon style="color: GRAY;">add_box</mat-icon>
</a> 
<a style="padding: 4px; text-align: center;" *ngIf="editIcon || (commitment && commitment.commitmentID > 0)" (click)="openAddOrEditCommitment()">
        <i matTooltip="עריכה ופרטים נוספים" class="fa fa-pencil"></i>
    </a>
    